/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useRef } from "react";
import { useThemeMode } from "../../../../../../_metronic/partials";
import { KTSVG } from "../../../../../../_metronic/helpers";
import { getCSSVariableValue } from "../../../../../../_metronic/assets/ts/_utils";
import { useIntl } from "react-intl";

type Props = {
  className: string;
  chartSize?: number;
  chartLine?: number;
  chartRotate?: number;
};

const CardsStatisticsAge0a10Masc: FC<Props> = ({
  className,
  chartSize = 60,
  chartLine = 5,
  chartRotate = 0,
}) => {
  const chartRef = useRef<HTMLDivElement | null>(null);
  const { mode } = useThemeMode();
  useEffect(() => {
    refreshChart();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mode]);

  const refreshChart = () => {
    if (!chartRef.current) {
      return;
    }

    setTimeout(() => {
      initChart(chartSize, chartLine, chartRotate);
    }, 10);
  };
  const intl = useIntl();
  return (
    <div className={`card card-flush ${className} solid-border`}>
      <div className="card-header pt-5 align-items-center justify-content-center">
        <div className="card-title d-flex flex-column d-flex align-items-center justify-content-center">
          <span className="fs-8hx fw-bold text-dark me-2 lh-1 ls-n2 mb-5">
            0 a 10
          </span>
          <div className="d-flex align-items-center">
            <span className="fs-8hx fw-bold text-dark me-2 lh-1 ls-n2">5%</span>
            <span className="badge badge-light-success fs-base">
              <KTSVG
                path="/media/icons/duotune/arrows/arr066.svg"
                className="svg-icon-5 svg-icon-success ms-n1"
              />
              25.8%
            </span>
          </div>
          <span className="text-gray-400 pt-1 fw-semibold fs-8">
            {intl.formatMessage({
              id: "MENU.DASHBOARD_PLANS_SALES.TOTAL_AMOUNT_USERS",
            })}
            100
          </span>
        </div>
      </div>

      <div className="card-body pt-2 pb-4 d-flex flex-wrap d-flex align-items-center justify-content-center">
        <div className="d-flex flex-center me-5 pt-2">
          <div
            id="kt_card_widget_0_10"
            ref={chartRef}
            style={{ minWidth: chartSize + "px", minHeight: chartSize + "px" }}
            data-kt-size={chartSize}
            data-kt-line={chartLine}
          ></div>
        </div>
      </div>
    </div>
  );
};

const initChart = function (
  chartSize: number = 70,
  chartLine: number = 11,
  chartRotate: number = 145
) {
  const el = document.getElementById("kt_card_widget_0_10");
  if (!el) {
    return;
  }
  el.innerHTML = "";

  var options = {
    size: chartSize,
    lineWidth: chartLine,
    rotate: chartRotate,
    //percent:  el.getAttribute('data-kt-percent') ,
  };

  const canvas = document.createElement("canvas");
  const span = document.createElement("span");

  // @ts-ignore
  if (typeof G_vmlCanvasManager !== "undefined") {
    // @ts-ignore
    G_vmlCanvasManager.initElement(canvas);
  }

  const ctx = canvas.getContext("2d");
  canvas.width = canvas.height = options.size;

  el.appendChild(span);
  el.appendChild(canvas);

  // @ts-ignore
  ctx.translate(options.size / 2, options.size / 2); // change center
  // @ts-ignore
  ctx.rotate((-1 / 2 + options.rotate / 180) * Math.PI); // rotate -90 deg

  //imd = ctx.getImageData(0, 0, 240, 240);
  const radius = (options.size - options.lineWidth) / 2;

  const drawCircle = function (
    color: string,
    lineWidth: number,
    percent: number
  ) {
    percent = Math.min(Math.max(0, percent || 1), 1);
    if (!ctx) {
      return;
    }

    ctx.beginPath();
    ctx.arc(0, 0, radius, 0, Math.PI * 2 * percent, false);
    ctx.strokeStyle = color;
    ctx.lineCap = "round"; // butt, round or square
    ctx.lineWidth = lineWidth;
    ctx.stroke();
  };

  // Init 2
  // drawCircle('#E4E6EF', options.lineWidth, 100 / 100)
  drawCircle(getCSSVariableValue("--bs-primary"), options.lineWidth, 100 / 100);
  drawCircle(getCSSVariableValue("--bs-warning"), options.lineWidth, 5 / 100);
};

export { CardsStatisticsAge0a10Masc };
